<script setup lang="ts">
import PersonalChat from "@/components/widget/ui/personalChat.vue";
import {nextTick, onMounted, ref, watch} from "vue";

interface IChatMessage {
  messages: IChatMessage[];
}

const props = withDefaults(defineProps<IChatMessage>(), {});

const listRef = ref<HTMLElement | null>(null)
const itemRefs = ref<HTMLElement[]>([]);

const setItemRef = (el: Element | null, index: number) => {
  if (el) {
    itemRefs.value[index] = el as HTMLElement;
  }
};

const scrollToBottom = async () => {
  await nextTick()

  if (listRef.value) {
    listRef.value.scrollTop = listRef.value.scrollHeight
  }
}

onMounted(() => {
  scrollToBottom()
})

watch(
    () => props.messages?.length,
    () => {
      scrollToBottom()
    }
)
</script>

<template>
  <div class="w-chat-panel">
    <div class="list" ref="listRef">
      <div
          v-for="(item, index) in [...messages].reverse()"
          :ref="(el: any) => setItemRef(el, index)"
          :key="item.id"
          class="list__item"
          :class="item.is_outgoing"
      >
        <PersonalChat :item="item"/>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.w-chat-panel {

  .list {
    height: calc(100vh - 149px);
    overflow: auto;
    padding: 16px;
  }
}
</style>
